"use strict";
/**
 * The files holds all names of bull queue instance
 *
 * All names should be kept here
 * to avoid using the same queue name for different queue
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROJECT_EXPORT_QUEUE = void 0;
/**
 * For project export operations
 */
exports.PROJECT_EXPORT_QUEUE = "project-export";
//# sourceMappingURL=queue-names.js.map